export interface IStorageSessionCredentials {
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken: string;
  region: string;
  endpoint: string;
  serviceName: string;
  expiration: string;
}

export enum LoadStorageFileErrorType {
  Unhandled = 'unhandled',
  BadUrl = 'badUrl',
}

export interface IRemoteFile {
  errorType: LoadStorageFileErrorType | null;
  fileData: Blob | null;
  url: string;
  onload: (() => void) | null;
  onerror: ((error: any) => void) | null;
  onabort: (() => void) | null;
}

export type TStorageSessionRequestMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
